var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiPost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.052,
    height: 32.072,
    viewBox: "0 0 32.052 32.072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6285",
    "data-name": "Group 6285",
    transform: "translate(-9797.991 1314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M-1117.5-122.174h.375c.125.066.258.015.386.031a1.587,1.587,0,0,0,.49-.031h.25a.839.839,0,0,0,.5,0h.626c.462.066.928.067,1.392.1a9.5,9.5,0,0,1,2.012.429,15.845,15.845,0,0,1,5.969,3.3,15.779,15.779,0,0,1,3.254,3.886.65.65,0,0,1,.145.4,13.317,13.317,0,0,1-2.325,3.144,16.886,16.886,0,0,1-1.963,1.771c-.124.093-.243.207-.42.126-.122-.177,0-.295.109-.4.336-.34.666-.687,1.023-1.006.494-.494.92-1.054,1.441-1.518a2.044,2.044,0,0,0,.274-2.744c-.053-.064-.087-.143-.143-.2a3.978,3.978,0,0,0-.879-.522,2.26,2.26,0,0,0-2.2.73,18.006,18.006,0,0,1-1.408,1.452c-.41.438-.823.872-1.274,1.269-.332.36-.639.741-.99,1.084-1.453,1.421-2.822,2.926-4.279,4.343-.157.153-.265.348-.433.492-.114.1-.223.192-.389.142a3.824,3.824,0,0,1-1.383-.075c-.056-.02-.123.012-.184.018a.486.486,0,0,1-.281-.122,3.613,3.613,0,0,0-2.062-.615c-1.125,0-2.249.024-3.374-.016-1.772.041-3.545.016-5.317.013a.511.511,0,0,1-.272-.055c-.176-.133-.064-.211.063-.262a1,1,0,0,1,.372-.032q2.988,0,5.976,0a1.421,1.421,0,0,1,.505.078,15.854,15.854,0,0,1-8.219-7.033c-.066-.172.039-.306.116-.435a15.988,15.988,0,0,1,2.044-2.712,16.2,16.2,0,0,1,4.5-3.415,15.314,15.314,0,0,1,4.3-1.467C-1118.615-122.126-1118.049-122.089-1117.5-122.174Z",
    transform: "translate(10930.134 -1191.826)",
    fill: "#c1e2f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M-868.82-15.613A3.6,3.6,0,0,0-869-14.556a15.775,15.775,0,0,1-1.765,5.206.83.83,0,0,1-.558.147c-.591.007-.6.02-.6.622a4.27,4.27,0,0,1-.084,1.173l-.068.116c-.16,0-.175-.12-.191-.234a3.932,3.932,0,0,1-.017-.531q0-4.284,0-8.567c0-.136,0-.271,0-.406-.01-.406-.093-.494-.5-.5-1.4-.006-2.793,0-4.19,0a3.208,3.208,0,0,1-.623-.031c-.225-.111-.162-.26-.042-.4.168-.2.364-.371.545-.558.348-.357.716-.694,1.032-1.084.114-.141.23-.3.444-.316a.14.14,0,0,1,.086.039,7.426,7.426,0,0,0,1.375-1.066,15.968,15.968,0,0,0,3.086-3.735c.047-.08.083-.171.189-.193.155-.011.216.1.277.212a14.958,14.958,0,0,1,1.636,4.566,14.254,14.254,0,0,1,.128,1.614c.005.081-.026.167.031.241v.564a.84.84,0,0,0,0,.5v.313c-.063.1-.017.214-.031.32.016.122-.034.251.031.369Z",
    transform: "translate(10698.862 -1280.983)",
    fill: "#259de4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M-1066,77.8l-.83-.006a.4.4,0,0,1-.121-.213,1.689,1.689,0,0,0-1.887-1.443c-1.207-.014-2.415,0-3.622-.006a1.032,1.032,0,0,1-.687-.144.707.707,0,0,1-.074-.424q-.01-1.657,0-3.313a.866.866,0,0,1,.083-.455.227.227,0,0,1,.089-.078,1.606,1.606,0,0,1,.584-.074c1.02,0,2.04,0,3.059,0,.5,0,.561-.062.564-.552,0-.073,0-.146,0-.219-.014-.338-.092-.425-.432-.43-.708-.01-1.415.007-2.123-.007a7.839,7.839,0,0,1-1.617-.059.236.236,0,0,1-.1-.055,1.5,1.5,0,0,1-.106-.818c-.015-.436-.072-.5-.513-.5-.466-.006-.933.011-1.4-.011-.145-.007-.327.012-.317-.226a.419.419,0,0,1,.34-.118c.682,0,1.363-.026,2.044.014.385-.025.771-.013,1.157-.023.3-.008.375-.078.37-.378,0-.243.084-.5-.1-.722a2.384,2.384,0,0,0-1.061-.16c-.149,0-.314.05-.437-.089a2.665,2.665,0,0,1,0-1.435c.106-.145.264-.1.4-.1a2.533,2.533,0,0,0,1.1-.158,1.183,1.183,0,0,0-.007-1.076,2.663,2.663,0,0,0-1.093-.149c-.138,0-.293.044-.4-.094a.83.83,0,0,1-.082-.423c-.005-.768-.007-1.536,0-2.3,0-.163-.016-.338.144-.454,1.178-.005,2.357-.016,3.535-.014a3.815,3.815,0,0,1,2.147.758,1.421,1.421,0,0,1,.9.934c0,.253-.249.354-.331.557a5.951,5.951,0,0,0-.281,1.175,3.356,3.356,0,0,0-.227,1.083c-.152.419-.181.871-.338,1.29-.023.061.02.1.061.128a11.531,11.531,0,0,0,1.248-.292c.177-.04.348-.08.463.118a1.753,1.753,0,0,1,.047.559q0,4.882,0,9.763C-1065.855,77.376-1065.794,77.621-1066,77.8Z",
    transform: "translate(10880.017 -1359.748)",
    fill: "#eef4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M-1111.151,61.037q0,1.592,0,3.184c-.084.165-.243.139-.383.143-.467.014-.934,0-1.4.008-.361.007-.433.084-.445.445-.026.807-.013.82.788.821.363,0,.727-.008,1.09.006.131.005.278-.011.351.144q0,.717,0,1.435c-.083.166-.243.141-.383.146-.385.013-.771,0-1.156.006-.677,0-.687.011-.69.674,0,.125,0,.25-.008.375a.377.377,0,0,1-.138.3.522.522,0,0,0,.359.066c.551,0,1.1.014,1.652,0,.294-.01.384.1.369.382-.018.352-.005.706-.005,1.06-.08.168-.241.143-.381.147-.468.014-.936,0-1.4.008-.365.007-.433.079-.443.444-.022.736,0,.757.724.759.385,0,.77-.008,1.154.006.131,0,.279-.011.35.146l.007,4.206c.011.1-.1.06-.134.11a14.244,14.244,0,0,1-2.053-1.23,14.276,14.276,0,0,1-2.265-1.941,14.206,14.206,0,0,1-1.31-1.537,8.524,8.524,0,0,1-.071-2.016c-.039-.688-.017-1.376-.018-2.064q0-2.83,0-5.66c0-.2-.068-.426.149-.573C-1114.945,61.012-1113.049,61.008-1111.151,61.037Z",
    transform: "translate(10918.091 -1359.689)",
    fill: "#f8fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M-1150.777-17.666q0,3.989,0,7.978c0,.115-.005.229-.008.344a1.34,1.34,0,0,1-1.3,0,15.4,15.4,0,0,1-1.833-5.766,15.864,15.864,0,0,1,1.957-9.76c.132.03.164.153.222.247a16.094,16.094,0,0,0,6.462,6.019c.6.31,1.215.584,1.844.871h-1.449l-5.539-.006C-1150.544-17.74-1150.679-17.78-1150.777-17.666Z",
    transform: "translate(10952.025 -1280.988)",
    fill: "#259de4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M-974.051,6.3l.376-.431a1.268,1.268,0,0,1,.827-.829l5.365-5.495c.189-.193.381-.383.572-.575a.428.428,0,0,1,.381.156c.187.214.441.37.556.645a.238.238,0,0,1,0,.092.786.786,0,0,1-.189.283c-.623.586-1.167,1.249-1.78,1.846-1,.975-1.954,2-2.925,3-.638.659-1.287,1.307-1.923,1.969a1.041,1.041,0,0,1-.374.277.222.222,0,0,1-.094,0c-.311-.21-.656-.385-.794-.772C-974.07,6.416-974.1,6.357-974.051,6.3Z",
    transform: "translate(10787.126 -1302.832)",
    fill: "#efd076"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M-852.678-36.41a2.077,2.077,0,0,1,.221,2.78,16.767,16.767,0,0,1-1.817,1.88c-.186.046-.283-.1-.4-.195a10.645,10.645,0,0,1-1.065-1.034.358.358,0,0,1-.1-.222.516.516,0,0,1,.212-.43c.5-.5.99-1.008,1.5-1.5.376-.36.676-.789,1.066-1.134C-852.947-36.358-852.849-36.474-852.678-36.41Z",
    transform: "translate(10678.778 -1270.397)",
    fill: "#c33071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M-873.577-41.439c.556-.579,1.094-1.178,1.674-1.732a2.075,2.075,0,0,1,2.09-.5c.114.149.016.255-.081.352-.843.851-1.64,1.748-2.506,2.577a.714.714,0,0,1-.288.181A1.447,1.447,0,0,1-873.577-41.439Z",
    transform: "translate(10695.033 -1263.679)",
    fill: "#dc8799"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M-863.416-39.582c.1-.109.19-.22.292-.325q1.219-1.254,2.442-2.506a.462.462,0,0,0,.153-.23,2.087,2.087,0,0,1,.881.539l-3.006,3.062a.565.565,0,0,0-.073.134.108.108,0,0,1-.081.033,1.2,1.2,0,0,1-.636-.621A.128.128,0,0,1-863.416-39.582Z",
    transform: "translate(10685.751 -1264.703)",
    fill: "#d6759f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M-869.406,1.761l.055,0,1.484,1.463c-.323.34-.646.678-.967,1.019-.078.083-.145.176-.217.264a.262.262,0,0,1-.055.007c-.279-.022-.4-.272-.595-.414a7.841,7.841,0,0,1-.845-.813.447.447,0,0,1-.127-.275.607.607,0,0,1,.195-.345,7.823,7.823,0,0,0,.723-.773A.288.288,0,0,1-869.406,1.761Z",
    transform: "translate(10692.371 -1305.374)",
    fill: "#eec042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M-1080.771-12.855c.146-.023.23.028.26.224a.7.7,0,0,0,.643.627c.22.028.205.152.206.3s0,.256-.2.279a.708.708,0,0,0-.655.649c-.031.205-.158.182-.291.184s-.259,0-.287-.193a.7.7,0,0,0-.659-.643c-.2-.024-.189-.155-.189-.291s-.021-.259.188-.284a.732.732,0,0,0,.661-.613C-1081.037-12.856-1081.037-12.857-1080.771-12.855Z",
    transform: "translate(10885.967 -1291.994)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M-976.227-11.69c.016.164,0,.278-.21.3a.7.7,0,0,0-.637.632c-.034.221-.166.195-.311.2s-.246-.027-.274-.211a.7.7,0,0,0-.642-.625c-.2-.027-.19-.153-.19-.291s-.014-.257.188-.287a.707.707,0,0,0,.647-.657c.023-.2.138-.2.281-.2s.272-.008.3.209a.7.7,0,0,0,.63.641C-976.244-11.943-976.2-11.853-976.227-11.69Z",
    transform: "translate(10791.169 -1292.027)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M-1013.2-69.3c-.161.02-.269-.014-.295-.215a.69.69,0,0,0-.632-.632c-.224-.031-.194-.165-.2-.308s.015-.248.2-.276a.692.692,0,0,0,.629-.635c.025-.192.142-.2.286-.2s.257-.012.292.187a.731.731,0,0,0,.688.655c.215.023.157.18.163.3s.02.24-.171.263a.731.731,0,0,0-.681.663C-1012.944-69.3-1013.051-69.293-1013.2-69.3Z",
    transform: "translate(10824.006 -1238.197)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M-886.3-15.188c0,.017,0,.035,0,.052a3.761,3.761,0,0,1-1.046,1.187.164.164,0,0,1-.2,0l-.874-.819c.4-.434.807-.858,1.242-1.257Z",
    transform: "translate(10708.631 -1289.096)",
    fill: "#f5e48b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M-977.51,70.268l-.827.829a6.116,6.116,0,0,0-.83-.945C-978.617,70.242-978.056,70.154-977.51,70.268Z",
    transform: "translate(10791.788 -1368.06)",
    fill: "#259de4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M-962.519,77.362q0-5.5,0-11.01c.02-.208.2-.221.34-.259.539-.144,1.082-.276,1.624-.407.636-.611,1.273-1.221,1.862-1.88.478-.534,1-1.027,1.516-1.525.493-.477.924-1.012,1.419-1.487.106-.1.2-.257.394-.163l5.162.006c.41,0,.411,0,.411.4q-.006,4.819-.01,9.637c0,.119-.046.251.05.359a16.6,16.6,0,0,1-4.914,4.279,1.917,1.917,0,0,1-.578.3c-1.4.173-2.807.046-4.211.081a5.46,5.46,0,0,0-.839.066,1.589,1.589,0,0,0-1.318,1.18.847.847,0,0,1-.2.414Z",
    transform: "translate(10776.578 -1359.29)",
    fill: "#f8fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M-954.073,241.236a1.745,1.745,0,0,1,1.819-1.776c1.335-.009,2.67-.005,4.006,0a2.436,2.436,0,0,1,.745.034,15.444,15.444,0,0,1-5.3,1.626C-953.223,241.173-953.649,241.2-954.073,241.236Z",
    transform: "translate(10768.793 -1523.192)",
    fill: "#259de4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M-1048.6,239.532c-.013-.106.1-.055.134-.11,1.481,0,2.962,0,4.443.013a1.71,1.71,0,0,1,1.776,1.287.918.918,0,0,1,.022.493,17.569,17.569,0,0,1-4.037-.744A22.661,22.661,0,0,1-1048.6,239.532Z",
    transform: "translate(10855.413 -1523.167)",
    fill: "#259de4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M-809.9,162.553a4.431,4.431,0,0,1-.054-1.268c-.006-.778-.109-.671.675-.68.208,0,.417,0,.625.006A12.945,12.945,0,0,1-809.9,162.553Z",
    transform: "translate(10636.751 -1450.944)",
    fill: "#259de4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M-949.376,20.282l-3.256,3.321c-.532.543-1.06,1.088-1.593,1.63-.071.072-.124.17-.237.191a.948.948,0,0,1-.508-.274c-.246-.236-.485-.479-.724-.722a.8.8,0,0,1-.289-.562,11.225,11.225,0,0,1,.821-.971.313.313,0,0,1,.043-.045c1.483-1.446,2.887-2.968,4.354-4.43.537-.535,1.048-1.1,1.587-1.633a.589.589,0,0,1,.331-.219.123.123,0,0,1,.08.036,14.188,14.188,0,0,0,1.221,1.2c.1.091.179.2.268.3Z",
    transform: "translate(10770.544 -1318.96)",
    fill: "#e48e22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M-1047.959,171.111c1.323,0,2.646,0,3.968-.006.247,0,.368.064.352.333a6.384,6.384,0,0,0,0,.812c.017.267-.071.368-.352.366-1.323-.013-2.645-.007-3.968-.008a.337.337,0,0,1-.133-.236,6.83,6.83,0,0,1,0-1.024A.334.334,0,0,1-1047.959,171.111Z",
    transform: "translate(10854.966 -1460.566)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M-1073.141,100.863c-.676,0-1.353-.008-2.029,0-.253,0-.361-.09-.351-.348.012-.291.012-.583,0-.874-.011-.258.1-.35.351-.347.676.009,1.353,0,2.029,0,.443,0,.886,0,1.329,0a.538.538,0,0,1,.357.063.413.413,0,0,1-.36.142c-.217.005-.435,0-.653,0a.608.608,0,0,0-.246.021c-.371.17-.174.505-.208.769a.282.282,0,0,0,.3.347c.259.012.518,0,.777.008a.443.443,0,0,1,.391.144,2.472,2.472,0,0,1-.915.061C-1072.624,100.873-1072.883,100.862-1073.141,100.863Z",
    transform: "translate(10880.08 -1394.765)",
    fill: "#d3e4fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M-1075.522,136.685c0-.393.009-.788-.005-1.181-.009-.247.091-.325.329-.322.683.009,1.367,0,2.051,0,.444,0,.888,0,1.332,0a.538.538,0,0,1,.358.063.425.425,0,0,1-.363.143c-.25.007-.5,0-.749.006a.323.323,0,0,0-.364.366c0,.187,0,.375-.006.562a.427.427,0,0,1-.145.362Z",
    transform: "translate(10880.087 -1427.65)",
    fill: "#d3e4fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M-981.721,103.518a3.893,3.893,0,0,0,.918,1.071c.16.174.385.279.516.484-.545.207-1.121.3-1.68.461-.13.037-.258.078-.387.118l-1.811.426a.567.567,0,0,1,.154-.359,24,24,0,0,1,2.153-2.2.145.145,0,0,1,.055-.028A.111.111,0,0,1-981.721,103.518Z",
    transform: "translate(10796.368 -1398.609)",
    fill: "#eec042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M-1073.09,171.1v1.5l-.066.007c-.676,0-1.353-.011-2.029,0-.249,0-.367-.065-.351-.334a7.027,7.027,0,0,0,0-.842c-.017-.268.1-.338.351-.334.676.011,1.353,0,2.029,0Z",
    transform: "translate(10880.095 -1460.553)",
    fill: "#d3e4fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M-982.3,97.627c-.014.151-.133.229-.226.322q-1.1,1.092-2.144,2.238c-.1-.132,0-.258.022-.379.087-.418.2-.831.3-1.247a1.659,1.659,0,0,1,.519-.753c.289-.243.479-.6.851-.747h.066a.664.664,0,0,1,.618.566Z",
    transform: "translate(10796.879 -1392.717)",
    fill: "#f6dd74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M-1044.723,101.472c-.436,0-.872-.006-1.308,0-.219,0-.33-.064-.32-.3.012-.28.012-.561,0-.841-.01-.236.1-.307.319-.3.436.01.872,0,1.308,0Z",
    transform: "translate(10853.353 -1395.439)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M-1046.335,137.391c0-.383.006-.766,0-1.149,0-.213.081-.3.293-.294.445.008.89,0,1.335,0,0,.384,0,.767.005,1.151.006.215-.082.3-.294.292C-1045.444,137.385-1045.89,137.391-1046.335,137.391Z",
    transform: "translate(10853.34 -1428.351)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M-979,87.473c-.038.189-.2.283-.317.409-.346.369-.734.7-1.053,1.092a22.008,22.008,0,0,1,.555-2.376,1.313,1.313,0,0,0,.487.549A1.547,1.547,0,0,1-979,87.473Z",
    transform: "translate(10792.894 -1383.129)",
    fill: "#f5e180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M-962.6,17.377l-.617-.565c.054-.064.1-.131.162-.19,1.2-1.23,2.412-2.455,3.612-3.689,1.025-1.054,2.04-2.118,3.06-3.175.094-.1.2-.183.3-.274a.652.652,0,0,1,.626.626c-.053.064-.1.132-.159.191-1.157,1.182-2.319,2.36-3.472,3.545-1.066,1.1-2.123,2.2-3.186,3.3-.079.082-.167.155-.251.232Z",
    transform: "translate(10777.171 -1312.468)",
    fill: "#eec042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M-877.334-3.562a4.121,4.121,0,0,0-.626-.626c0-.019,0-.039,0-.058A7.775,7.775,0,0,0-877-5.216a.493.493,0,0,1,.289-.22,4.609,4.609,0,0,1,.629.619l-1.189,1.258Z",
    transform: "translate(10699.05 -1298.796)",
    fill: "#f6dd74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6284",
    "data-name": "Group 6284",
    transform: "translate(9817.234 -1293.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M-854.492,142.035a.143.143,0,0,1-.145.073c-.2,0-.4,0-.6,0-.049,0-.07.01-.068.064,0,.141,0,.282,0,.423h-.012a.1.1,0,0,1-.021-.081c0-.155,0-.311.007-.466,0-.176-.01-.352-.008-.528,0-.032-.007-.067.021-.094h.012c0,.143,0,.286,0,.43,0,.049.017.059.062.058.2,0,.4,0,.6,0a.143.143,0,0,1,.145.073Z",
    transform: "translate(860.868 -138.822)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M-883.814,176.319a.143.143,0,0,1-.073-.145c0-.23,0-.459,0-.689a.224.224,0,0,1,.2,0c0,.23,0,.459,0,.689a.143.143,0,0,1-.073.145Z",
    transform: "translate(886.977 -169.944)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M-867.861,176.314a.193.193,0,0,1-.051-.152c0-.227,0-.454,0-.681a.193.193,0,0,1,.191,0c0,.232,0,.463,0,.695a.143.143,0,0,1-.063.138Z",
    transform: "translate(872.369 -169.939)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M-891.574,175.482c0,.231,0,.463,0,.694a.149.149,0,0,1-.062.139h-.075a.181.181,0,0,1-.052-.151c0-.227,0-.454,0-.682A.192.192,0,0,1-891.574,175.482Z",
    transform: "translate(894.178 -169.94)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M-875.834,176.312a.15.15,0,0,1-.062-.139c0-.231,0-.463,0-.694a.192.192,0,0,1,.191,0c0,.232,0,.464,0,.7a.137.137,0,0,1-.064.135Z",
    transform: "translate(879.67 -169.936)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M-899.556,175.482c0,.232,0,.464,0,.7a.141.141,0,0,1-.064.137h-.062a.142.142,0,0,1-.063-.138c0-.232,0-.463,0-.695a.192.192,0,0,1,.191,0Z",
    transform: "translate(901.476 -169.939)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M-855.179,155.071c.223,0,.446,0,.669,0a.15.15,0,0,1,.139.062v.075a.181.181,0,0,1-.151.052c-.219,0-.439,0-.658,0a.215.215,0,0,1,0-.186Z",
    transform: "translate(860.747 -151.3)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M-854.374,131.356a.193.193,0,0,1-.152.051c-.219,0-.438,0-.657,0a.2.2,0,0,1,0-.187c.224,0,.448,0,.672,0a.142.142,0,0,1,.138.063Z",
    transform: "translate(860.75 -129.488)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M-855.183,163.05c.224,0,.448,0,.672,0a.14.14,0,0,1,.137.064v.062a.142.142,0,0,1-.138.063c-.224,0-.448,0-.671,0A.2.2,0,0,1-855.183,163.05Z",
    transform: "translate(860.75 -158.593)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M-854.367,139.326a.15.15,0,0,1-.139.062c-.223,0-.446,0-.669,0l0,0a.215.215,0,0,1,0-.186c.225,0,.45,0,.674,0a.136.136,0,0,1,.135.064Z",
    transform: "translate(860.743 -136.787)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M-905.967,121.718c0,.062,0,.124,0,.186a.1.1,0,0,0-.009.066c0,.172.007.343.008.515s-.007.351-.008.527c0,.022-.006.046.009.066l0,.186v.5q0,.094,0,.187c0,.178,0,.356,0,.534a.34.34,0,0,1-.2.332.353.353,0,0,1-.157.031h-4.036a.338.338,0,0,1-.267-.1.337.337,0,0,1-.1-.266c0-.178,0-.356,0-.534a.208.208,0,0,1,0-.187v-.5a.208.208,0,0,1,0-.187h0a3.351,3.351,0,0,0,0-.47c0-.052-.033-.109-.018-.162a2.552,2.552,0,0,0,.023-.516.039.039,0,0,0-.006-.024h0a.208.208,0,0,1,0-.187v-.5a.208.208,0,0,1,0-.187c0-.191,0-.381,0-.572a.347.347,0,0,1,.141-.3.34.34,0,0,1,.2-.062h.572a.244.244,0,0,1,.192,0l.481,0a.26.26,0,0,1,.2,0h.481a.262.262,0,0,1,.2,0h.481a.26.26,0,0,1,.2,0h.481a.244.244,0,0,1,.192,0h.553a.336.336,0,0,1,.266.1.336.336,0,0,1,.1.266c0,.191,0,.381,0,.572q0,.094,0,.187Q-905.967,121.47-905.967,121.718Z",
    transform: "translate(911.534 -119.304)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M-919.115,141.415c.02.019.012.043.011.065,0,.17-.006.339-.008.508s.008.355.008.533c0,.022.008.046-.011.065,0-.143,0-.286,0-.429,0-.047-.013-.06-.06-.06-.2,0-.4,0-.6,0-.1,0-.147-.033-.147-.1s.05-.1.147-.1c.2,0,.4,0,.6,0,.047,0,.06-.013.06-.06C-919.117,141.7-919.115,141.558-919.115,141.415Z",
    transform: "translate(919.925 -138.813)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M-883.7,111.847h-.2c0-.215,0-.43,0-.645a.252.252,0,0,1,.014-.091.086.086,0,0,1,.088-.057.086.086,0,0,1,.082.057.261.261,0,0,1,.014.091Q-883.7,111.525-883.7,111.847Z",
    transform: "translate(886.986 -111.053)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M-919.119,155.089v.187h-.69c-.073,0-.116-.033-.118-.09s.043-.1.119-.1Z",
    transform: "translate(919.929 -151.316)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M-919.124,163.072v.187h-.7a.1.1,0,0,1-.111-.078c-.014-.06.036-.109.11-.109Z",
    transform: "translate(919.933 -158.615)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M-919.119,139.225q0,.094,0,.187h-.665a.391.391,0,0,1-.05,0,.1.1,0,0,1-.094-.1.1.1,0,0,1,.034-.067.1.1,0,0,1,.072-.022Z",
    transform: "translate(919.928 -136.811)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M-919.118,131.243v.187h-.7c-.07,0-.115-.04-.112-.1s.045-.09.113-.09Z",
    transform: "translate(919.928 -129.512)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M-875.706,111.839h-.2q0-.326,0-.653a.238.238,0,0,1,.007-.074.084.084,0,0,1,.1-.066.085.085,0,0,1,.081.087c0,.085,0,.17,0,.255v.379A.1.1,0,0,0-875.706,111.839Z",
    transform: "translate(879.68 -111.044)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M-891.685,111.832h-.2a.1.1,0,0,0,.013-.072v-.6c0-.076.035-.121.094-.12s.093.045.093.123c0,.213,0,.427,0,.64C-891.688,111.812-891.686,111.822-891.685,111.832Z",
    transform: "translate(894.29 -111.038)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M-867.727,111.832h-.193l0-.641c0-.019,0-.037,0-.056a.1.1,0,0,1,.093-.1.094.094,0,0,1,.067.029.093.093,0,0,1,.026.068c0,.089,0,.178,0,.268Q-867.728,111.618-867.727,111.832Z",
    transform: "translate(872.374 -111.038)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M-899.562,111.832h-.192q0-.317,0-.634c0-.019,0-.037,0-.056a.1.1,0,0,1,.025-.072.1.1,0,0,1,.069-.032.1.1,0,0,1,.069.031.1.1,0,0,1,.024.072c0,.106,0,.212,0,.317C-899.563,111.583-899.562,111.707-899.562,111.832Z",
    transform: "translate(901.482 -111.038)",
    fill: "#c4dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M-904.908,128.138h-1.73a.31.31,0,0,1-.349-.349v-3.46a.31.31,0,0,1,.349-.349h3.461a.31.31,0,0,1,.349.349v3.46a.31.31,0,0,1-.349.349Z",
    transform: "translate(908.096 -122.872)",
    fill: "#b0d2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M-880.574,130.724a.2.2,0,0,1,.186.205q0,1.031,0,2.063a.065.065,0,0,1-.02.014.274.274,0,0,1-.086.007h-1.225a.062.062,0,0,1-.049-.018.061.061,0,0,1-.017-.049q0-.283,0-.566a.072.072,0,0,1,.022-.057.072.072,0,0,1,.058-.02,1.77,1.77,0,0,1,.242,0c.033.007.044.034.057.06a.335.335,0,0,0,.383.19.335.335,0,0,0,.251-.276.331.331,0,0,0-.176-.347c-.026-.014-.061-.019-.072-.055a.3.3,0,0,1-.006-.08v-.974a.146.146,0,0,1,.017-.1A4,4,0,0,1-880.574,130.724Z",
    transform: "translate(885.056 -129.033)",
    fill: "#b0d2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M-896.185,140.576h-.136a.19.19,0,0,1-.168-.2c0-.149,0-.3,0-.448v-1.53a.189.189,0,0,1,.015-.109.067.067,0,0,1,.046-.017c.13,0,.259-.008.389,0a.046.046,0,0,1,.026.015.523.523,0,0,0,.147.155.057.057,0,0,1,.021.037c.011.186,0,.373,0,.559,0,.153.009.161.163.161.068,0,.137,0,.205,0s.091.017.092.093c0,.166,0,.332,0,.5v.69a.151.151,0,0,1-.017.1h-.6a.084.084,0,0,1-.016-.053c0-.166-.005-.331,0-.5a.07.07,0,0,1,.007-.02c.028-.033.07-.049.1-.083a.251.251,0,0,0,.064-.23.251.251,0,0,0-.157-.18.252.252,0,0,0-.325.127.261.261,0,0,0,.1.326.137.137,0,0,1,.051.045.174.174,0,0,1,.012.079q0,.2,0,.4A.11.11,0,0,1-896.185,140.576Z",
    transform: "translate(898.5 -135.932)",
    fill: "#b0d2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M-896.322,130.735l.025,0a.115.115,0,0,1,.043,0h1.582a.128.128,0,0,1,.043,0,.1.1,0,0,1,.02.082q0,.5,0,1a.173.173,0,0,1-.012.079.1.1,0,0,1-.048.038.371.371,0,0,0-.174.172c-.012.024-.025.048-.055.055-.238.01-.476,0-.714,0a.062.062,0,0,1-.052-.018.062.062,0,0,1-.017-.052c0-.165-.007-.331,0-.5a.051.051,0,0,1,.025-.035.278.278,0,0,0,.187-.284.272.272,0,0,0-.178-.239.281.281,0,0,0-.333.125.087.087,0,0,1-.048.047,2.142,2.142,0,0,1-.428,0,.032.032,0,0,1-.017-.024.971.971,0,0,1,.007-.313A.173.173,0,0,1-896.322,130.735Z",
    transform: "translate(898.489 -129.041)",
    fill: "#b0d2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M-888.941,140.451c0,.169,0,.339,0,.508,0,.043.012.056.056.056.244,0,.488,0,.731,0a.378.378,0,0,1,0,.188c-.089,0-.178,0-.267,0-.04,0-.054.013-.054.054,0,.188,0,.377,0,.565,0,.054.026.053.065.053h1.242l.062,0a.564.564,0,0,1,0,.189.164.164,0,0,1-.1.016h-1.125c-.018,0-.037,0-.056,0-.047,0-.067.018-.067.066,0,.108,0,.215,0,.323a.129.129,0,0,1-.019.089h-.185q0-.634,0-1.268c0-.1.012-.087-.091-.088h-.261c-.078,0-.111-.032-.111-.108q0-.326,0-.653A.284.284,0,0,1-888.941,140.451Z",
    transform: "translate(891.766 -137.913)",
    fill: "#edebf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M-899.682,138.26c0,.683,0,1.366,0,2.049a.23.23,0,0,0,.151.242l-.248,0a.208.208,0,0,1-.162-.059.208.208,0,0,1-.062-.161c0-.014,0-.029,0-.044V138.34c0-.027,0-.054,0-.081a.527.527,0,0,1,.213-.016A.142.142,0,0,1-899.682,138.26Z",
    transform: "translate(901.711 -135.909)",
    fill: "#95c7ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M-881.541,159.893c0-.143,0-.286,0-.429,0-.054.011-.07.068-.07.409,0,.817,0,1.226,0l.075,0c.005-.005.008,0,.01,0,0,.1,0,.195,0,.292a.2.2,0,0,1-.058.147.2.2,0,0,1-.146.059C-880.758,159.9-881.149,159.894-881.541,159.893Z",
    transform: "translate(884.829 -155.249)",
    fill: "#b0d2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M-899.662,136.163h-.32v-.194a.053.053,0,0,1,.037-.019,1.987,1.987,0,0,1,.245,0,.061.061,0,0,1,.038.018l.448,0a1.181,1.181,0,0,1,0,.2C-899.363,136.157-899.512,136.162-899.662,136.163Z",
    transform: "translate(901.691 -133.811)",
    fill: "#edebf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M-899.685,131.242l-.321,0c0-.081,0-.161,0-.242a.206.206,0,0,1,.06-.164.206.206,0,0,1,.164-.059l.235,0a.245.245,0,0,0-.138.264C-899.679,131.11-899.684,131.177-899.685,131.242Z",
    transform: "translate(901.714 -129.088)",
    fill: "#95c7ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M-893.027,159.121q0-.25,0-.5a.122.122,0,0,0-.01-.072,1.531,1.531,0,0,1,.2,0l0,.572Z",
    transform: "translate(895.342 -154.477)",
    fill: "#edebf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M-865.551,157.441l-.01,0v-.184l.011,0Q-865.551,157.347-865.551,157.441Z",
    transform: "translate(870.219 -153.294)",
    fill: "#858c9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M-875.264,144.44a.349.349,0,0,1,.254.346.341.341,0,0,1-.268.327.36.36,0,0,1-.208-.213.36.36,0,0,1,.024-.3.34.34,0,0,1,.188-.163Z",
    transform: "translate(879.312 -141.579)",
    fill: "#95c7ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M-875,130.814h.186q0,.543,0,1.087c0,.027,0,.054,0,.081a.006.006,0,0,1,0,.006.974.974,0,0,1-.2,0,.131.131,0,0,0,.01-.079Q-875,131.36-875,130.814Z",
    transform: "translate(878.856 -129.12)",
    fill: "#edebf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M-877.643,144.308a.3.3,0,0,1,.2,0,.384.384,0,0,0-.214.247.345.345,0,0,0,.17.387c.014.007.032.012.032.033a.346.346,0,0,1-.41-.211l-.014-.034a.456.456,0,0,1,0-.187A.359.359,0,0,1-877.643,144.308Z",
    transform: "translate(881.491 -141.444)",
    fill: "#8ccaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M-891.191,134.345a.311.311,0,0,1,0-.2.288.288,0,0,1,.151-.164.289.289,0,0,1,.223-.007c0,.028-.025.036-.042.049a.274.274,0,0,0-.115.223.274.274,0,0,0,.115.223c.017.013.042.021.042.049l-.026.013a.573.573,0,0,1-.185-.011A.328.328,0,0,1-891.191,134.345Z",
    transform: "translate(893.668 -131.991)",
    fill: "#8ccaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M-894.639,152.977a.29.29,0,0,1-.2,0,.272.272,0,0,1-.168-.272.269.269,0,0,1,.206-.244.224.224,0,0,1,.163.014c.007.03-.02.038-.035.053a.252.252,0,0,0-.1.2.252.252,0,0,0,.1.2c.014.013.037.022.03.049Z",
    transform: "translate(897.143 -148.904)",
    fill: "#8ccaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M-892.29,153.217a.352.352,0,0,1-.132-.167.248.248,0,0,1,.066-.272l.068-.063a.255.255,0,0,1,.173.245.261.261,0,0,1-.175.257Z",
    transform: "translate(894.793 -149.145)",
    fill: "#95c7ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M-888.494,134.718a.334.334,0,0,1-.159-.183.287.287,0,0,1,.119-.33l.04-.03a.281.281,0,0,1,.192.275.281.281,0,0,1-.191.269Z",
    transform: "translate(891.345 -132.193)",
    fill: "#95c7ee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPost);
export default __webpack_public_path__ + "static/media/ai_post.0a9721c874efce9a392a8a6c65ba6043.svg";
export { ForwardRef as ReactComponent };